export enum adminApplicationsStatusPostTypes {
    FETCH_ADMIN_APPLICATIONS_STATUS_POST_REQUEST = "FETCH_ADMIN_APPLICATIONS_STATUS_POST_REQUEST",
    FETCH_ADMIN_APPLICATIONS_STATUS_POST_SUCCESS = "FETCH_ADMIN_APPLICATIONS_STATUS_POST_SUCCESS",
    FETCH_ADMIN_APPLICATIONS_STATUS_POST_FAILURE = "FETCH_ADMIN_APPLICATIONS_STATUS_POST_FAILURE",
  }